export default __webpack_public_path__ + "static/media/10C.0cc64a48.svg";